/** Mock de contatos / favorecidos Pix (mesma base do ContactSelector). */
export const PIX_FAVORITE_CONTACTS = [
  {
    id: "edu-nubank",
    name: "Eduardo Martins",
    bankName: "Nubank",
    pixKeyDisplay: "edu.martins@email.com",
    pixKeyType: "email",
    pixKeyValue: "edu.martins@email.com",
  },
  {
    id: "edu-bradesco",
    name: "Eduardo Martins",
    bankName: "Bradesco",
    pixKeyDisplay: "048.275.841-41",
    pixKeyType: "cpf",
    pixKeyValue: "04827584141",
  },
  {
    id: "leo-nubank",
    name: "Leo Martins",
    bankName: "Nubank",
    pixKeyDisplay: "(11) 99999-0000",
    pixKeyType: "phone",
    pixKeyValue: "5511999990000",
  },
];
